// extracted by mini-css-extract-plugin
export default {"image":"ErrorSearch__image--QeEzj"};